import logger from './logger';

const geolocationService = {
  detectCoords(timeoutMs = 10000) {
    return new Promise((resolve, reject) => {
      const timer = setTimeout(() => {
        reject(new Error('timed out'));
      }, timeoutMs);

      navigator.geolocation.getCurrentPosition(
        position => {
          clearTimeout(timer);
          logger.log('Geo Position', position);
          if (position) {
            resolve(position.coords);
          } else {
            reject(new Error('Position not available'));
          }
        },
        error => {
          clearTimeout(timer);
          reject(error);
        }
      );
    });
  }
};
export default geolocationService;
